/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { fromJS } from 'immutable'
import { toast } from "react-toastify";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ReactLoading from 'react-loading';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { UserLoggedIn,PrevilageId} from '../../helper/HelperAuth';

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import CustomGrid from '../../infra/components/grid/custom-grid'

import imageuser from '../../source/user.png'
import { chatdetail, chatlist, messages, chatHistory, historymessages } from '../../store/selector/chatSelector'
import ActionGetTemplate from '../../store/action/Template/Fetch'
import ActionGetTemplateFirstPage from '../../store/action/Template/FetchFirstPage'
import FetchQueue from '../../store/action/Chat/FetchQueue'
import FetchChat from '../../store/action/Chat/FetchChat'
import SendChat from '../../store/action/Chat/SendChat'
import SendMedia from '../../store/action/Chat/SendMedia'
import SendLocation from '../../store/action/Chat/SendLocation'
import CloseTicket from '../../store/action/Chat/CloseTicket'
import FetchHistory from '../../store/action/Chat/FetchListHistory'
import FetchChatHistory from '../../store/action/Chat/FetchChatHistory'
import FetchCategory from '../../store/action/Category/FetchBySender'
import FetchPriority from '../../store/action/Priority/FetchBySender'
import ClearListHistory from '../../store/action/Chat/ClearListHistory'
import './Overview.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import ActionGetGroupTemplate from "../../store/action/GroupTemplate/Fetch";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'


class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentChat: fromJS({}),
            currentChatHistory: fromJS({}),
            form: fromJS({
                'textmessage': '',
                'attachmenturl': '',
                'latitude': '',
                'longitude': '',
                'attachmentcaption': '',
                'attachmenttype': '',
                'templatesearch': '',
                'category-id': '',
                'priority-id': '',
                'disabled': true
            }),
            showModal: false,
            isadmin:false,
            showModalHistory: false,
            columns: [
                { className: "col-sm-1", cfield: "counter", caption: "No" },
                { className: "col-sm-10", field: "message-template", caption: "Message" },
                {
                    className: "col-sm-1",
                    cfield: "action",
                    caption: "Actions",
                    allowView: false,
                    allowDelete: false,
                    allowEdit: false,
                    allowSelect: true,
                }
            ],
            modal: fromJS({
            }),
            formModal : fromJS({
                "group-id"    : '',
            }),
            errors: fromJS({}),
            tableHide:'col-sm-12 hidden'
        }
        this.handleSelectChatList = this.handleSelectChatList.bind(this)
        this.renderChatHeader = this.renderChatHeader.bind(this)
        this.renderChatMessage = this.renderChatMessage.bind(this)
        this.renderChatAction = this.renderChatAction.bind(this)
        this.handleSendMessage = this.handleSendMessage.bind(this)
        this.handleChange = this.handleChange.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.renderChatQueue = this.renderChatQueue.bind(this);
        this.messagesEnd = ''
        this.handleAttachment = this.handleAttachment.bind(this);
        this.handleLocation = this.handleLocation.bind(this);
        this.handleTemplate = this.handleTemplate.bind(this);
        this.handleChangeGroupTemplate = this.handleChangeGroupTemplate.bind(this);

        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.renderModalBody = this.renderModalBody.bind(this);
        this.renderModalAction = this.renderModalAction.bind(this);
        this.handleSubmitModal = this.handleSubmitModal.bind(this);
        this.handleCloseTicket = this.handleCloseTicket.bind(this);

        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleSelectRow = this.handleSelectRow.bind(this);

        this.renderChatHistory = this.renderChatHistory.bind(this);
        this.handleSelectHistoryList = this.handleSelectHistoryList.bind(this);
        this.renderChatQueueItem = this.renderChatQueueItem.bind(this);
        this.handleTemplateButtonClicked = this.handleTemplateButtonClicked.bind(this);
    }

    async componentDidMount() {
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
        this.props.fetchQueue();
        this.props.fetchCategory();
        this.props.fetchPriority();
        this.scrollToBottom();
        this.props.actionGetTemplateFirstPage();

        setInterval(() => {
            if (this.state.currentChat.size > 0 && this.state.currentChatHistory.size === 0) {
                this.props.fetchChat(this.state.currentChat.get('chat-id'))
            }
        }, 1000);


        setInterval(() => {
            this.props.fetchQueue();
        }, 30000);
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    handleChange(field, value) {
        if (value == null) {
            // eslint-disable-next-line no-restricted-globals
            value = event.target.value;
        }
        var formVal = this.state.form;
        formVal = formVal.set(field, value);
        this.setState({ form: formVal })
    }

    handleChangeGroupTemplate(field, value, label) {
        let tableHide = 'col-sm-12'
        if (value == null) {
            // eslint-disable-next-line no-restricted-globals
            value = event.target.value;
            tableHide='col-sm-12 hidden'
        }

        var formValModal = this.state.formModal;
        formValModal = formValModal.set(field,value);
        let bodyFind = {
            'sender-id' : [""],
            'group-id' : value
        }
        this.props.actionGetTemplate(1,null,bodyFind);
        this.setState({formModal:formValModal,tableHide:tableHide})
    }


    handleSelectChatList(chat) {
        //debugger
        console.log(chat)
        this.setState({
            currentChat: chat,
            currentChatHistory: fromJS({}),
            form: this.state.form.set('disabled', false)
        })
        this.props.fetchChat(chat.get('chat-id'))
        this.props.fetchHistory(chat.get('msisdn'));
    }

    handleAttachment() {
        this.setState({
            modal: fromJS({
                'type': 'attachment',
                'title': 'Send Media',
            }),
            form: fromJS({
                'textmessage': '',
                'attachmenturl': '',
                'latitude': '',
                'longitude': '',
                'attachmentcaption': '',
                'attachmenttype': '',
                'templatesearch': '',
             
            }),
            showModal: true,
        })
    }

    handleLocation() {
        this.setState({
            modal: fromJS({
                'type': 'location',
                'title': 'Send Location',
            }),
            showModal: true,
            form: fromJS({
                'textmessage': '',
                'attachmenturl': '',
                'latitude': '',
                'longitude': '',
                'attachmentcaption': '',
                'attachmenttype': '',
                'templatesearch': '',
             
            }),
        })
    }

    handleSelectRow(row) {
        this.setState({
            form: this.state.form.set('textmessage', row.get('message-template'))
        })
        this.handleCloseModal()
    }

    handleTemplate() {
        // this.props.actionGetTemplate(1, fromJS({}));
        this.props.actionGetGroupTemplate(1,"",this.state.isadmin);
        this.setState({
            modal: fromJS({
                'type': 'template',
                'title': 'Chat Template',
            }),
            showModal: true,
            formModal : fromJS({
                "group-id"    : '',
            }),
            tableHide:'col-sm-12 hidden'
        })
    }

    handleTemplateButtonClicked(text) {
        this.setState({ form: this.state.form.set('textmessage', text) })
    }

    handlePageChanged = (value) => {
        const {formModal} = this.state
        var groupsId = formModal.get('group-id');
        let bodyFind = {
            'sender-id' : [""],
            'group-id' : groupsId
        }
        this.props.actionGetTemplate(value, fromJS({}),bodyFind);
    }

    handleCloseModal() {
        this.setState({
            modal: fromJS({
            }),
            showModal: false,
            showModalHistory: false,
        })
    }


    handleSelectHistoryList(chat) {
        this.setState({
            showModalHistory: true,
            currentChatHistory: chat,
        })
        this.props.fetchChatHistory(chat.get('ticket-no'))
    }


    async handleSendMessage() {
        const { form, currentChat } = this.state
        if (currentChat.size === 0) {
            toast.error('no selected queue!', toast.POSITION.TOP_RIGHT);
            return;
        }

        if (form.get('textmessage') === '') {
            toast.error('cannot send empty message!', toast.POSITION.TOP_RIGHT);
            return;
        }

        this.setState({
            form: this.state.form.set('disabled', true)
        })

        var response = await this.props.sendChat(fromJS({
            'chat-id': currentChat.get('chat-id'),
            'message': form.get('textmessage')
        }))

        if (response.ok) {
            this.setState({
                form: this.state.form.set('disabled', false).set('textmessage', '')
            })

            this.props.fetchChat(currentChat.get('chat-id'));
            this.props.fetchQueue();
        } else {
            toast.error('Send failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    async handleSubmitModal() {
        const { modal, form, currentChat } = this.state

        if (currentChat.get('chat-id') == null) {
            toast.error("no ticket selected", toast.POSITION.TOP_RIGHT);
            return false;
        }

        if (modal.get('type') === 'location') {
            if (form.get('latitude') === '' || form.get('longitude') === '') {
                toast.error("Empty mandatory field!", toast.POSITION.TOP_RIGHT);
                return false;
            }

            this.setState({
                form: this.state.form.set('disabled', true)
            })

            var response = await this.props.sendLocation(fromJS({
                'chat-id': currentChat.get('chat-id'),
                'lat': form.get('latitude'),
                'long': form.get('longitude'),
            }))

            if (response.ok) {
                toast.success("Send Location Success!", toast.POSITION.TOP_RIGHT);
                this.handleCloseModal()
            }

            this.props.fetchChat(currentChat.get('chat-id'))
            this.props.fetchQueue();
        } else if (modal.get('type') === 'attachment') {
            if (form.get('attachmenturl') === '') {
                toast.error("Empty mandatory field!", toast.POSITION.TOP_RIGHT);
                return false;
            }

            this.setState({
                form: this.state.form.set('disabled', true)
            })

            var response = await this.props.sendMedia(fromJS({
                'chat-id': currentChat.get('chat-id'),
                //'content-type': form.get('attachmenttype'),
                'url': form.get('attachmenturl'),
                'caption': form.get('attachmentcaption'),
            }))

            if (response.ok) {
                toast.success("Send Media Success!", toast.POSITION.TOP_RIGHT);
                this.handleCloseModal()
            }

            this.props.fetchChat(currentChat.get('chat-id'))
            this.props.fetchQueue();
        }

        this.setState({
            form: this.state.form.set('disabled', false).set('textmessage', '')
        })
    }

    async handleCloseTicket() {
        const { currentChat, form } = this.state

        if (!form.get('category-id') || !form.get('priority-id')) {
            toast.error("Category and Priority cannot be empty!", toast.POSITION.TOP_RIGHT);
            return false;
        } else {
            if (window.confirm('Are you sure?')) {
                var response = await this.props.closeTicket(fromJS({
                    'chat-id': currentChat.get('chat-id'),
                    'category-id': form.get('category-id'),
                    'priority-id': form.get('priority-id'),
                }))

                // if (response.ok) {
                if (response.get('success')) {
                    // toast.success('CLose Ticket Success!', toast.POSITION.TOP_RIGHT);
                    toast.success(response.get('message'), toast.POSITION.TOP_RIGHT);
                    this.setState({
                        form: this.state.form.set('disabled', false).set('textmessage', '')
                    })
                    this.setState({
                        form: this.state.form.set('priority-id', fromJS({}))
                    })
                    this.setState({
                        form: this.state.form.set('category-id', fromJS({}))
                    })

                    this.props.clearListHistory()
                    this.props.fetchQueue();
                    this.setState({ 
                        currentChat: fromJS({}), 
                        currentChatHistory: fromJS({}) 
                    });
                    
                } else {
                    toast.error('Close Ticket failed!', toast.POSITION.TOP_RIGHT);
                }
            }
        }
    }

    scrollToBottom = () => {
        //if (this.messagesEnd !== '') {
        //    this.messagesEnd.scrollTop = this.messagesEnd.scrollHeight;
        //}
    }

    render() {
        const { messages, historymessages } = this.props
        const { currentChat, showModal, modal, currentChatHistory } = this.state
        var msgs = messages.get(currentChat.get('chat-id')) != null ? messages.get(currentChat.get('chat-id')) : fromJS([])

        var historyMsg = fromJS({})
        var historyTitle = ''
        if (currentChatHistory.size > 0) {
            historyTitle = currentChatHistory.get('ticket-no')
            historyMsg = historymessages.get(currentChatHistory.get('ticket-no')) != null ? historymessages.get(currentChatHistory.get('ticket-no')) : fromJS([])
        }

        return (
            <div id="chat-container">
                <div className="col-md-12 nopadding">
                    <div className="col-md-3 col-xl-3 chat nopadding">
                        {this.renderChatQueue()}
                    </div>
                    <div className="col-md-6  nopadding">
                        <div className="card noborder-left noborder-right card_noborderradius">
                            <div className="header">
                                {this.renderChatHeader()}
                            </div>
                            <div className="body msg_card_body2" ref={(el) => { this.messagesEnd = el; }}>
                                {
                                    msgs.map((value) => {
                                        return this.renderChatMessage(value)
                                    })
                                }
                            </div>

                            {this.renderChatAction()}
                        </div>
                    </div>
                    <div className="col-md-3 nopadding">
                        {this.renderChatHistory()}
                    </div>
                </div>

                <Modal isOpen={showModal} toggle={() => { }} fade={false} >
                    <ModalHeader>
                        {modal.get('title')}
                    </ModalHeader>
                    <ModalBody>
                        {this.renderModalBody()}
                    </ModalBody>
                    <ModalFooter>
                        {this.renderModalAction()}
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.showModalHistory} toggle={() => { }} fade={false} >
                    <ModalHeader>
                        <div className="row">
                            <div className="col-md-8">
                                {historyTitle}
                                <div className="chat-history-info">
                                    <a href="#/" >
                                        <p>{currentChatHistory.get('ticket-date')}</p>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="input-group">
                                    <div style={{ width: "100%" }}></div>
                                    <div className="input-group-btn">
                                        <button className="btn btn-warning" type="submit" onClick={this.handleCloseModal} >
                                            <span> <i className="material-icons">cancel</i> Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {
                            historyMsg.map((value) => {
                                return this.renderChatMessage(value)
                            })
                        }
                    </ModalBody>
                </Modal>
            </div>
        )
    }

    renderChatHistory() {
        const { history } = this.props
        const { currentChat } = this.state
        var ticketno = '';
        return (
            <div className="card mb-sm-3 mb-md-0 contacts_card noborder-right card_noborderradius">
                <div className="header">
                    <h5>TICKET HISTORY</h5>
                </div>
                <div className="body contacts_body">
                    <ul className="">
                        {
                            history.map((item, i) => {
                                if (item.get('ticket-no') != undefined) {
                                    if (item.get('ticket-no').length < 25) {
                                        ticketno = item.get('ticket-no');
                                    } else {
                                        ticketno = item.get('ticket-no').substring(0, 25) + '...'
                                    }
                                }
                                return (
                                    <li className={item.get('chat-id') === currentChat.get('chat-id') ? "list-group-item active" : " list-group-item"} >

                                        <div className="chat-history-info">
                                            <a href="#/" onClick={() => this.handleSelectHistoryList(item)} >
                                                <span>{ticketno}</span>
                                                {/* <p>Handled By : Mamat</p> */}
                                                <p className="tgl-history">{item.get('ticket-date')}</p>
                                            </a>
                                        </div>

                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    }

    renderModalAction() {
        const { currentChat, form,modal } = this.state

        var btnSend = ''
        if (form.get('disabled')) {
            if (currentChat.size > 0) {
                btnSend =
                    <div className="input-group-btn">
                        <ReactLoading type="bubbles" color="#FF9800" className="react-loading" width={50} />
                    </div>
            }
        } else {
            btnSend =
                <div className="input-group-btn">
                    <a className="btn btn-success" type="submit" onClick={this.handleSubmitModal} disabled={form.get('disabled')} >
                        <span> Send <i className="material-icons">send</i> </span>
                    </a>
                </div>
        }
        if (modal.get('type') === 'template') {
            btnSend = ''
        }
        return (
            <div className="input-group">
                <div style={{ width: "100%" }}></div>
                {btnSend}
                <div className="input-group-btn">
                    <button className="btn btn-warning" type="submit" onClick={this.handleCloseModal} disabled={form.get('disabled')} >
                        <span> <i className="material-icons">cancel</i> </span>
                    </button>
                </div>
            </div>
        )
    }

    renderModalBody() {
        const { modal, form, columns } = this.state
        if (form.get('disabled')) {
            return (
                <div className="body">
                    <div className="form-group row">
                        <div className="col-sm-9">
                            <ReactLoading type="spin" color="#FF9800" className="react-loading" width={300} />
                        </div>
                    </div>
                </div>
            )
        } else if (modal.get('type') === 'location') {
            return (
                <div className="body">
                    <div className="form-group row">
                        <span className="col-sm-3">Latitude *</span>
                        <div className="col-sm-9">
                            <TextInputField className="form-control"
                                field={'latitude'}
                                value={form.get('latitude')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="latitude"
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <span className="col-sm-3">longitude *</span>
                        <div className="col-sm-9">
                            <TextInputField className="form-control"
                                field={'longitude'}
                                value={form.get('longitude')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="longitude"
                            />
                        </div>
                    </div>
                </div>
            )
        } else if (modal.get('type') === 'attachment') {
            return (
                <div className="body">
                    <div className="form-group row">
                        <span className="col-sm-3">URL *</span>
                        <div className="col-sm-9">
                            <TextInputField className="form-control"
                                field={'attachmenturl'}
                                value={form.get('attachmenturl')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="url of attachment"
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <span className="col-sm-3">Caption *</span>
                        <div className="col-sm-9">
                            <TextInputField className="form-control"
                                textarea
                                field={'attachmentcaption'}
                                value={form.get('attachmentcaption')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="caption"
                            />
                        </div>
                    </div>
                </div>
            )
        } else if (modal.get('type') === 'template') {
            const items = this.props.template ? fromJS(this.props.template) : fromJS({});
            const {formModal, errors,tableHide} = this.state;
            return (
                <div className="body">
                    {/*<CustomGrid
                        columns={columns}
                        items={items}
                        handlePageChanged={this.handlePageChanged}
                        handleSelectRow={this.handleSelectRow}
                    >
                    </CustomGrid>*/}
                    <div className="form-group row">
                    <div className="col-sm-12">
                        <ComboboxInput
                            field='group-id'
                            value={formModal.get('group-id')}
                            options={fromJS({
                                'source': this.props.grouptemplate,
                                'value': 'group-id',
                                'label': 'group-name'
                            }) }
                            onChange={(field, value, label) => this.handleChangeGroupTemplate(field,value,label)}
                            placeholder="Group Template"
                            disabled={this.state.disabled}
                            hasError={errors.has('group-id')}
                        />
                    </div>
                    </div>
                    <div className={tableHide} >
                        <CustomGrid
                            columns={columns}
                            items={items}
                            handlePageChanged={this.handlePageChanged}
                            handleSelectRow={this.handleSelectRow}
                        >
                        </CustomGrid>
                    </div>
                </div>
            )
        }
    }

    renderChatHeader() {
        const { currentChat, form } = this.state
        let chatdetail = this.props.chatdetail !== undefined ? this.props.chatdetail : fromJS({})
        var category = this.props.categories.get('data') !== undefined ? this.props.categories.get('data') : fromJS([]);
        var priority = this.props.priority.get('data') !== undefined ? this.props.priority.get('data') : fromJS([]);
        if (currentChat.size > 0) {
            return (
                <div className="row">
                    <div className="row border-bottom">
                        <div className="col-md-12">
                            <div className="chat-header-left">
                                <div className="img_cont">
                                    <img src={imageuser} className="img-circle user_img" alt="User" />
                                </div>
                                <div className="user_info">
                                    <div className="phonenumber">{currentChat.get('msisdn')}</div>
                                    <div className="senddate">{currentChat.get('date-queue')}</div>
                                </div>
                            </div>
                            <div class="chat-header-right">
                                <div className="ticket_no">
                                    <div className="ticket_lbl">
                                        Ticket No
                                    </div>
                                    <div className="ticket_dtl">
                                        <CopyToClipboard text={chatdetail.get('ticket-no')}
                                                         onCopy={() => this.setState({copied: true})}>
                                            <button className="btn btn-primary btn-sm" data-toggle="tooltip" title="Copy To Clipboard">{chatdetail.get('ticket-no')}</button>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row margin0">
                        <div className="col-md-5 col-sm-12">
                            <ComboboxInput
                                customcss="form-control"
                                field='category-id'
                                value={form.get('category-id')}
                                options={fromJS({
                                    'source': category,
                                    'value': 'category-id',
                                    'label': 'category-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Category"
                                disabled={this.state.disabled}
                            />
                        </div>

                        <div className="col-md-4 col-sm-12">
                            <ComboboxInput
                                customcss="form-control"
                                field='priority-id'
                                value={form.get('priority-id')}
                                options={fromJS({
                                    'source': priority,
                                    'value': 'priority-id',
                                    'label': 'priority-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Priority"
                                disabled={this.state.disabled}
                            />
                        </div>
                        <div className="col-md-3 col-sm-12">
                            <button className="btn btn-danger btn-sm" type="submit" onClick={this.handleCloseTicket} >
                                <span>Close Ticket</span>
                            </button>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="d-flex bd-highlight">
                    {/* <div className="img_cont">
                    </div> */}
                    <div className="no-chat">
                        <h5>NO CHAT SELECTED...</h5>
                    </div>
                </div>
            )
        }
    }

    renderChatMessage(msg) {
        var data = msg.get('data');
        var caption = data.get('caption');
        var lat = data.get('lat');
        var media = data.get('media-url');
        if (lat !== '' && data.get('lat') !== undefined && data.get('long') !== undefined) {
            lat = <div><a href={"https://www.google.com/maps?q=loc:" + data.get('lat') + "," + data.get('long')} target="_blank">
                <i className="material-icons">location_on</i>
            </a>
                <span>
                    {data.get('lat') + "," + data.get('long')}
                </span>
            </div>
        }
        if (media !== '') {
            if(media.match(/\.(jpeg|jpg|gif|png)$/) != null){
                media = <div>
                <a href={data.get('media-url')} target="_blank" alt="image">

                    <img src={media} width="50"/>
                </a>
            </div>
            }else{
                media = <div>
                <a href={data.get('media-url')} target="_blank">

                    <i className="material-icons">file_copy</i>
                </a>
            </div>
            }
            
        }

        const msgtype = msg.get('type') !== undefined ? msg.get('type') : msg.get('bubble_type');

        if (msgtype === 'inbound') {
            return (
                <div className="d-flex justify-content-start mb-4">
                    <span className="dot-chat-cs">
                        <i className="material-icons">person</i>
                    </span>
                    <div className="msg_container" style={{ whiteSpace: "pre-line" }}>
                        {media}
                        {lat}
                        {caption}
                    </div>
                    <span className="msg_time">{msg.get('bubble-date')}</span>
                </div>
            )
        } else {
            return (
                <div className="d-flex justify-content-end mb-4">
                    <span className="msg_time_send">{msg.get('bubble-date')}</span>
                    <div className="msg_container_send" style={{ whiteSpace: "pre-line" }}>
                        {media}
                        {lat}
                        {caption}
                    </div>
                    <span className="dot-chat-user">
                        <i className="material-icons">person</i>
                    </span>
                </div>
            )
        }
    }

    renderChatAction() {
        const { form, currentChat, currentChatHistory } = this.state

        var btnSend = ''
        if (form.get('disabled')) {
            if (currentChat.size > 0) {
                btnSend =
                    <ReactLoading type="bubbles" color="#FF9800" className="react-loading" width={50} />
            }
        } else {
            btnSend =

                <a type="submit" onClick={this.handleSendMessage} disabled={form.get('disabled')} >
                    <span><i className="material-icons">send</i></span>
                </a>
        }

        if (currentChat.size > 0) {
            return (
                <div className="card-footer2">
                    {/*<div className="row border-bottom tags_scroll">
                        <div className="form-line focused">
                            {
                                this.props.templatefirst.map((item) => {
                                    return (
                                        <a type="submit" className="tagsinput" onClick={() => this.handleTemplateButtonClicked(item.get('message-template'))}>
                                            <span className="tag lbl_template label-info">{item.get('message-template')}
                                            </span>
                                        </a>
                                    )
                                })
                            }
                        </div>
                        </div>*/}
                    <div className="input-group input-chat-margin">
                        <div className="input-group-btn">
                            <a type="submit" onClick={this.handleLocation} >
                                <i className="material-icons">location_on</i>
                            </a>
                            <a type="submit" onClick={this.handleAttachment}>
                                <i className="material-icons">attach_file</i>
                            </a>
                            <a type="submit" onClick={this.handleTemplate}>
                                <i className="material-icons">view_headline</i>
                            </a>
                        </div>
                        <div className="area-padding">
                            <TextInputField className="form-control no-resize area-border"
                                textarea
                                row={3}
                                field={'textmessage'}
                                value={form.get('textmessage')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Type message..."
                                disabled={form.get('disabled')}
                            />
                        </div>
                        <div className="input-group-btn">
                            {btnSend}

                        </div>
                    </div>
                </div>
            )
        }
    }

    renderChatQueue() {
        const { currentChat } = this.state
        const { chatlist } = this.props
        var active = fromJS([]);
        var newticket = fromJS([]);
        var queue = chatlist.get('queues') != null ? chatlist.get('queues') : fromJS([]);
        if (chatlist.has('active')) {
            active = chatlist.get('active') != null ? chatlist.get('active') : fromJS([]);
        }
        if (chatlist.has('new-ticket')) {
            newticket = chatlist.get('new-ticket') != null ? chatlist.get('new-ticket') : fromJS([]);
        }

        if(queue.size>0){
            var tempData = [];
            for (var j = 0; j < queue.size; j++) {
                let chatId = queue.get(j).get("chat-id");
                let msisdn = queue.get(j).get("msisdn");
                let username = queue.get(j).get("username");
                let message = queue.get(j).get("message");
                let dateQue = queue.get(j).get("date-queue");
                let dateMess = queue.get(j).get("date-message");
                tempData.push({
                    "chat-id": chatId,
                    "msisdn": msisdn,
                    "username": username,
                    "message": message,
                    "date-queue": dateQue,
                    "dateMessage": dateMess
                })
            }
        //     //debugger;
        //     var nData = fromJS({});
        //     queue.map((item) => {
        //         return item.set('dateMessage', item.get('date-message'))
        //     })
    
            tempData.sort((c, d) => c.dateMessage > d.dateMessage ? -1:1)
            queue = fromJS(tempData);
        }
        if(newticket.size>0){
            newticket = sortingData(newticket);
            if(PrevilageId == 4){
                newticket = sortdata(newticket)
            }
        }

        if(active.size>0){
            active = sortingData(active);
            if(PrevilageId == 4){
                active = sortdata(active)
            }
        }

        function sortdata(data){
            if(data.size>0){
                var tempData = [];
                for (var j = 0; j < data.size; j++) {
                    let chatId = data.get(j).get("chat-id");
                    let msisdn = data.get(j).get("msisdn");
                    let username = data.get(j).get("username");
                    let message = data.get(j).get("message");
                    let dateQue = data.get(j).get("date-queue");
                    let dateMess = data.get(j).get("date-message");
                    tempData.push({
                        "chat-id": chatId,
                        "msisdn": msisdn,
                        "username": username,
                        "message": message,
                        "date-queue": dateQue,
                        "dateMessage": dateMess
                    })
                }
            //     //debugger;
            //     var nData = fromJS({});
            //     queue.map((item) => {
            //         return item.set('dateMessage', item.get('date-message'))
            //     })
        
                tempData.sort((c, d) => c.dateMessage > d.dateMessage ? -1:1)
                data = fromJS(tempData);
            }
            return data
        }

        function sortingData(dataSort){
            var tempDataActive = [];
            var lengthActive = dataSort.size;
            var result = [];
            //debugger
            if(lengthActive>0){
                for(var i = 0; i < lengthActive; i++){
                    let csId = dataSort.get(i).get("cs-id");
                    let csName = dataSort.get(i).get("cs-name");
                    let arrChats = dataSort.get(i).get("chats");
                    //debugger
                    if(arrChats) {
                        //debugger;
                        if (arrChats.size > 0) {
                            let chatsLength = arrChats.size;
                            for (var j = 0; j < chatsLength; j++) {
                                let chatId = arrChats.get(j).get("chat-id");
                                let msisdn = arrChats.get(j).get("msisdn");
                                let username = arrChats.get(j).get("username");
                                let message = arrChats.get(j).get("message");
                                let dateQue = arrChats.get(j).get("date-queue");
                                let dateMess = arrChats.get(j).get("date-message");
                                tempDataActive.push({
                                    "cs-id": csId,
                                    "cs-name": csName,
                                    "chat-id": chatId,
                                    "msisdn": msisdn,
                                    "username": username,
                                    "message": message,
                                    "date-queue": dateQue,
                                    "dateMessage": dateMess
                                })
                            }
                        }
                    }
                }
                tempDataActive.sort((a, b) => a.dateMessage > b.dateMessage ? -1:1)
                tempDataActive.sort((a, b) => a.dateMessage < b.dateMessage ? 1:-1)
                console.log(tempDataActive)
                var newTemp = fromJS(tempDataActive);
                let tempCount =tempDataActive.length;
                if(tempCount>0){
                    for(var k=0; k<tempCount; k++){
                        let newCsId = tempDataActive[k]["cs-id"];
                        let newCsName = tempDataActive[k]["cs-name"];
                        result.push({
                            "cs-id" : newCsId,
                            "cs-name":newCsName,
                            "chats":fromJS([newTemp.get(k)])
                        });
                    }
                    dataSort= fromJS(result);
                }
            }
            return dataSort
        }
        return (
            <div className="card mb-sm-3 mb-md-0 contacts_card noborder-left card_noborderradius">
                <div className="header">
                    <h5>INBOX</h5>
                </div>
                <div className="body contacts_body">
                    <ul>
                        <li>

                            <ul className="contacts-content">
                                {
                                    queue.map((item, i) => {
                                        return this.renderChatQueueItem(currentChat, item, '', 'queue')
                                    })
                                }
                            </ul>
                        </li>
                        <li>

                            <ul className="contacts-content">
                                {
                                    newticket.map((item, i) => {

                                        return this.renderChatQueueActive(currentChat, item, 'new')
                                    })
                                }

                            </ul>
                        </li>
                        <li>

                            <ul className="contacts-content">
                                {
                                    active.map((item, i) => {
                                        return this.renderChatQueueActive(currentChat, item, 'on-process')
                                    })
                                }
                            </ul>
                        </li>

                    </ul>

                </div>
            </div>
        )
    }

    renderChatQueueItem(currentChat, item, cs, type) {
        if(type==='new' && cs===''){
            cs=UserLoggedIn.get('FullName');
        }
        return (
            <li className={"chat-item-content " + (item.get('chat-id') === currentChat.get('chat-id') ? "active" : "")} >
                <a href="#/" onClick={() => this.handleSelectChatList(item)} >
                    <div className="d-flex bd-highlight">
        <div className={"chat-label " + type}></div>
                        <div className="chat-icon">
                            <i className="material-icons">chat</i>
                            {/* <span class="label-count">100</span> */}
                        </div>
                        <div className="user_info">
                            <p>{item.get('date-queue')}</p>
                            <span>{item.get('username')}</span>
                            <p>Handled By : {cs}</p>
                            <p>{item.get('message')}</p>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </a>
            </li>
        );
    }

    renderChatQueueActive(currentChat, cs, type) {
        if (cs.get('chats') !== null && cs.get('chats') !== undefined) {
            var csname = '';
            if (cs.get('cs-name') !== null && cs.get('cs-name') !== undefined) {
                csname = cs.get('cs-name');
            }
            return (
                cs.get('chats').map((item) => {
                    return this.renderChatQueueItem(currentChat, item, csname, type);
                })

            )
        } else {
            return this.renderChatQueueItem(currentChat, cs, '', type);
        }
    }
}


export default connect(
    (state) => {
        return {
            chatlist: chatlist(state),
            messages: messages(state),
            chatdetail: chatdetail(state),
            template: state.user.template,
            categories: state.user.categories,
            priority: state.user.priority,
            history: chatHistory(state),
            historymessages: historymessages(state),
            templatefirst: state.user.templatefirst,
            grouptemplate: state.user.grouptemplate,
        }
    },
    dispatch => bindActionCreators({
        actionGetTemplate: ActionGetTemplate,
        fetchQueue: FetchQueue,
        fetchChat: FetchChat,
        sendChat: SendChat,
        sendMedia: SendMedia,
        sendLocation: SendLocation,
        closeTicket: CloseTicket,
        fetchHistory: FetchHistory,
        fetchChatHistory: FetchChatHistory,
        fetchCategory: FetchCategory,
        fetchPriority: FetchPriority,
        actionGetTemplateFirstPage: ActionGetTemplateFirstPage,
        clearListHistory: ClearListHistory,
        actionFindByGroupId:ActionFindByGroupId,
        actionGetGroupTemplate: ActionGetGroupTemplate

    }, dispatch),
)(Page);